import api from './api';

const technicianLocationService = {
  // Shop Admin methods
  getLiveLocations: async () => {
    const response = await api.get('/technicians/live-locations');
    return response.data;
  },

  getRouteHistory: async (technicianId, date) => {
    const url = date
      ? `/technicians/${technicianId}/route-history?date=${date}`
      : `/technicians/${technicianId}/route-history`;
    const response = await api.get(url);
    return response.data;
  },

  // Technician Portal methods
  loginTechnician: async (phone, pin) => {
    const response = await api.post('/technicians/auth/login', { phone, pin });
    return response.data;
  },

  updateLocation: async (locationData) => {
    const response = await api.post('/technicians/location', locationData);
    return response.data;
  },

  getMyJobs: async () => {
    const response = await api.get('/technicians/portal/my-jobs');
    return response.data;
  },

  updateStatus: async (status, isTrackingActive) => {
    const response = await api.patch('/technicians/portal/status', { status, isTrackingActive });
    return response.data;
  }
};

export default technicianLocationService;
